import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from '@material-ui/core/FormControl';


const useStyles = makeStyles({
    selectRoot:
    {
        "&:focus": {
            backgroundColor: "#F0F0F0",
            color: "#DC251A",
           
           
        },
        fontWeight: 600,
        backgroundColor: "#F0F0F0",
        paddingLeft: '9px',
        paddingTop: '8px',
        paddingBottom: '7px',
        fontSize: '15px',
        height: '17px'
       
    },

    select:
    {
        backgroundColor: "white",
        fontSize: '15px',
        color: "#DC251A",
        height: '32.5px',
        width: '31px',
        marginTop: '-4px',
        border: 'solid 1px #E8E8E8'
    },
});

const DropdownDatabase = ({ statecategoria, handlechangecategory, unique }) => {
    const classes = useStyles();

    return (
        <FormControl style={{ marginTop: '-6px', backgroundColor: 'white',  marginLeft: '-10px', fontSize: '16px' }}>

            <Select classes={{ root: classes.selectRoot, icon: classes.select }}
                displayEmpty
                disableUnderline={true}
                style={{ width: '200px', height: '40px', paddingLeft: '9px', fontFamily: 'Montserrat', fontWeight: '600', fontSize: '15px' }}
                value={statecategoria}
                onChange={handlechangecategory}
                inputProps={{ 'aria-label': 'Without label' }} >
                <MenuItem style={{ fontFamily: 'Montserrat', fontWeight: '500', color: 'black',  fontSize: '15px' }} value="" > All Event types</MenuItem>
                {unique}
            </Select>
        </FormControl>
    )
}

export default DropdownDatabase;